const COUNTRIES = {
  Afghanistan: {
    nl: 'Afghanistan1',
    de: 'Afghanistan',
  },
  Albania: {
    nl: 'Albanië',
    de: 'Albanien',
  },
  Algeria: {
    nl: 'Algerije',
    de: 'Algerien',
  },
  'American Samoa': {
    nl: 'Amerikaans-Samoa',
    de: 'Amerikanisch-Samoa',
  },
  Andorra: {
    nl: 'Andorra',
    de: 'Andorra',
  },
  Angola: {
    nl: 'Angola',
    de: 'Angola',
  },
  Anguilla: {
    nl: 'Anguilla',
    de: 'Anguilla',
  },
  Antarctica: {
    nl: 'Antarctica',
    de: 'Antarktis',
  },
  'Antigua and Barbuda': {
    nl: 'Antigua en Barbuda',
    de: 'Antigua und Barbuda',
  },
  Argentina: {
    nl: 'Argentinië',
    de: 'Argentinien',
  },
  Armenia: {
    nl: 'Armenië',
    de: 'Armenien',
  },
  Aruba: {
    nl: 'Aruba',
    de: 'Aruba',
  },
  Australia: {
    nl: 'Australië',
    de: 'Australien',
  },
  Austria: {
    nl: 'Oostenrijk',
    de: 'Österreich',
  },
  Azerbaijan: {
    nl: 'Azerbeidzjan',
    de: 'Aserbaidschan',
  },
  'Bahamas (the)': {
    nl: "Bahama's (de)",
    de: 'Bahamas (die)',
  },
  Bahrain: {
    nl: 'Bahrein',
    de: 'Bahrain',
  },
  Bangladesh: {
    nl: 'Bangladesh',
    de: 'Bangladesch',
  },
  Barbados: {
    nl: 'Barbados',
    de: 'Barbados',
  },
  Belarus: {
    nl: 'Wit-Rusland',
    de: 'Weißrussland',
  },
  Belgium: {
    nl: 'België',
    de: 'Belgien',
  },
  Belize: {
    nl: 'Belize',
    de: 'Belize',
  },
  Benin: {
    nl: 'Benin',
    de: 'Benin',
  },
  Bermuda: {
    nl: 'Bermuda',
    de: 'Bermuda',
  },
  Bhutan: {
    nl: 'Bhutan',
    de: 'Bhutan',
  },
  'Bolivia (Plurinational State of)': {
    nl: 'Bolivia (Plurinationale staat)',
    de: 'Bolivien (Plurinationaler Staat)',
  },
  'Bonaire, Sint Eustatius and Saba': {
    nl: 'Bonaire, Sint Eustatius en Saba',
    de: 'Bonaire, Sint Eustatius und Saba',
  },
  'Bosnia and Herzegovina': {
    nl: 'Bosnië en Herzegovina',
    de: 'Bosnien und Herzegowina',
  },
  Botswana: {
    nl: 'Botswana',
    de: 'Botswana',
  },
  'Bouvet Island': {
    nl: 'Bouvet Eiland',
    de: 'Bouvetinsel',
  },
  Brazil: {
    nl: 'Brazilië',
    de: 'Brasilien',
  },
  'British Indian Ocean Territory (the)': {
    nl: 'Brits Territorium in de Indische Oceaan (de)',
    de: 'Britisches Territorium im Indischen Ozean (das)',
  },
  'Brunei Darussalam': {
    nl: 'Brunei Darussalam',
    de: 'Brunei Darussalam',
  },
  Bulgaria: {
    nl: 'Bulgarije',
    de: 'Bulgarien',
  },
  'Burkina Faso': {
    nl: 'Burkina Faso',
    de: 'Burkina Faso',
  },
  Burundi: {
    nl: 'Burundi',
    de: 'Burundi',
  },
  'Cabo Verde': {
    nl: 'Cabo Verde',
    de: 'Cabo Verde',
  },
  Cambodia: {
    nl: 'Cambodja',
    de: 'Kambodscha',
  },
  Cameroon: {
    nl: 'Kameroen',
    de: 'Kamerun',
  },
  Canada: {
    nl: 'Canada',
    de: 'Kanada',
  },
  'Cayman Islands (the)': {
    nl: 'Kaaimaneilanden (de)',
    de: 'Kaimaninseln (die)',
  },
  'Central African Republic (the)': {
    nl: 'Centraal-Afrikaanse Republiek (de)',
    de: 'Zentralafrikanische Republik (die)',
  },
  Chad: {
    nl: 'Tsjaad',
    de: 'Tschad',
  },
  Chile: {
    nl: 'Chili',
    de: 'Chile',
  },
  China: {
    nl: 'China',
    de: 'China',
  },
  'Christmas Island': {
    nl: 'Kerstmis Eiland',
    de: 'Weihnachtsinsel',
  },
  'Cocos (Keeling) Islands (the)': {
    nl: 'Cocos (Keeling) Eilanden (de)',
    de: 'Kokosinseln (Keeling) (die)',
  },
  Colombia: {
    nl: 'Colombia',
    de: 'Kolumbien',
  },
  'Comoros (the)': {
    nl: 'Comoren (de)',
    de: 'Komoren (die)',
  },
  'Congo (the Democratic Republic of the)': {
    nl: 'Congo (de Democratische Republiek)',
    de: 'Kongo (die)", "Kongo (Demokratische Republik)',
  },
  'Congo (the)': {
    nl: 'Congo (de)',
    de: 'Kongo (die)',
  },
  'Cook Islands (the)': {
    nl: 'Cookeilanden (de)',
    de: 'Cookinseln (die)',
  },
  'Costa Rica': {
    nl: 'Costa Rica',
    de: 'Costa Rica',
  },
  Croatia: {
    nl: 'Kroatië',
    de: 'Kroatien',
  },
  Cuba: {
    nl: 'Cuba',
    de: 'Kuba',
  },
  Curaçao: {
    nl: 'Curaçao',
    de: 'Curaçao',
  },
  Cyprus: {
    nl: 'Cyprus',
    de: 'Zypern',
  },
  Czechia: {
    nl: 'Tsjechië',
    de: 'Tschechien',
  },
  "Côte d'Ivoire": {
    nl: 'Ivoorkust',
    de: "Côte d'Ivoire",
  },
  Denmark: {
    nl: 'Denemarken',
    de: 'Dänemark',
  },
  Djibouti: {
    nl: 'Djibouti',
    de: 'Dschibuti',
  },
  Dominica: {
    nl: 'Dominica',
    de: 'Dominica',
  },
  'Dominican Republic (the)': {
    nl: 'Dominicaanse Republiek (de)',
    de: 'Dominikanische Republik (die)',
  },
  Ecuador: {
    nl: 'Ecuador',
    de: 'Ecuador',
  },
  Egypt: {
    nl: 'Egypte',
    de: 'Ägypten',
  },
  'El Salvador': {
    nl: 'El Salvador',
    de: 'El Salvador',
  },
  'Equatorial Guinea': {
    nl: 'Equatoriaal Guinea',
    de: 'Äquatorial-Guinea',
  },
  Eritrea: {
    nl: 'Eritrea',
    de: 'Eritrea',
  },
  Estonia: {
    nl: 'Estland',
    de: 'Estland',
  },
  Eswatini: {
    nl: 'Eswatini',
    de: 'Eswatini',
  },
  Ethiopia: {
    nl: 'Ethiopië',
    de: 'Äthiopien',
  },
  'Falkland Islands (the) [Malvinas]': {
    nl: 'Falklandeilanden (de) [Malvinas]',
    de: 'Falklandinseln (die) [Malwinen]',
  },
  'Faroe Islands (the)': {
    nl: 'Faeröer (de)"',
    de: 'Färöer Inseln (die)',
  },
  Fiji: {
    nl: 'Fiji',
    de: 'Fidschi',
  },
  Finland: {
    nl: 'Finland',
    de: 'Finnland',
  },
  France: {
    nl: 'Frankrijk',
    de: 'Frankreich',
  },
  'French Guiana': {
    nl: 'Frans Guyana',
    de: 'Französisch-Guayana',
  },
  'French Polynesia': {
    nl: 'Frans Polynesië',
    de: 'Französisch-Polynesien',
  },
  'French Southern Territories (the)': {
    nl: 'Franse Zuidelijke Gebieden',
    de: 'Französische Südgebiete (die)',
  },
  Gabon: {
    nl: 'Gabon',
    de: 'Gabun',
  },
  'Gambia (the)': {
    nl: 'Gambia (the)',
    de: 'Gambia (die)',
  },
  Georgia: {
    nl: 'Georgië',
    de: 'Georgien',
  },
  Germany: {
    nl: 'Duitsland',
    de: 'Deutschland',
  },
  Ghana: {
    nl: 'Ghana',
    de: 'Ghana',
  },
  Gibraltar: {
    nl: 'Gibraltar',
    de: 'Gibraltar',
  },
  Greece: {
    nl: 'Griekenland',
    de: 'Griechenland',
  },
  Greenland: {
    nl: 'Groenland',
    de: 'Grönland',
  },
  Grenada: {
    nl: 'Grenada',
    de: 'Grenada',
  },
  Guadeloupe: {
    nl: 'Guadeloupe',
    de: 'Guadeloupe',
  },
  Guam: {
    nl: 'Guam',
    de: 'Guam',
  },
  Guatemala: {
    nl: 'Guatemala',
    de: 'Guatemala',
  },
  Guernsey: {
    nl: 'Guernsey',
    de: 'Guernsey',
  },
  Guinea: {
    nl: 'Guinea',
    de: 'Guinea',
  },
  'Guinea-Bissau': {
    nl: 'Guinee-Bissau',
    de: 'Guinea-Bissau',
  },
  Guyana: {
    nl: 'Guyana',
    de: 'Guyana',
  },
  Haiti: {
    nl: 'Haïti',
    de: 'Haiti',
  },
  'Heard Island and McDonald Islands': {
    nl: 'Heard- en McDonaldseilanden',
    de: 'Heard Island und McDonald Islands',
  },
  'Holy See (the)': {
    nl: 'Heilige Stoel (de)',
    de: 'Heiliger Stuhl (der)',
  },
  Honduras: {
    nl: 'Honduras',
    de: 'Honduras',
  },
  'Hong Kong': {
    nl: 'Hong Kong',
    de: 'Hongkong',
  },
  Hungary: {
    nl: 'Hongarije',
    de: 'Ungarn',
  },
  Iceland: {
    nl: 'IJsland',
    de: 'Island',
  },
  India: {
    nl: 'India',
    de: 'Indien',
  },
  Indonesia: {
    nl: 'Indonesië',
    de: 'Indonesien',
  },
  'Iran (Islamic Republic of)': {
    nl: 'Iran (Islamitische Republiek)',
    de: 'Iran (Islamische Republik)',
  },
  Iraq: {
    nl: 'Irak',
    de: 'Irak',
  },
  Ireland: {
    nl: 'Ierland',
    de: 'Irland',
  },
  'Isle of Man': {
    nl: 'Eiland Man',
    de: 'Isle of Man',
  },
  Israel: {
    nl: 'Israël',
    de: 'Israel',
  },
  Italy: {
    nl: 'Italië',
    de: 'Italien',
  },
  Jamaica: {
    nl: 'Jamaica',
    de: 'Jamaika',
  },
  Japan: {
    nl: 'Japan',
    de: 'Japan',
  },
  Jersey: {
    nl: 'Jersey',
    de: 'Jersey',
  },
  Jordan: {
    nl: 'Jordanië',
    de: 'Jordanien',
  },
  Kazakhstan: {
    nl: 'Kazachstan',
    de: 'Kasachstan',
  },
  Kenya: {
    nl: 'Kenia',
    de: 'Kenia',
  },
  Kiribati: {
    nl: 'Kiribati',
    de: 'Kiribati',
  },
  "Korea (the Democratic People's Republic of)": {
    nl: 'Korea (de Democratische Volksrepubliek)',
    de: 'Korea (Demokratische Volksrepublik)',
  },
  'Korea (the Republic of)': {
    nl: 'Korea (Republiek Korea)',
    de: 'Korea (die Republik)',
  },
  Kuwait: {
    nl: 'Koeweit',
    de: 'Kuwait',
  },
  Kyrgyzstan: {
    nl: 'Kirgizstan',
    de: 'Kirgisistan',
  },
  "Lao People's Democratic Republic (the)": {
    nl: 'Lao Democratische Volksrepubliek (de)',
    de: 'Demokratische Volksrepublik Laos (die)',
  },
  Latvia: {
    nl: 'Letland',
    de: 'Lettland',
  },
  Lebanon: {
    nl: 'Libanon',
    de: 'Libanon',
  },
  Lesotho: {
    nl: 'Lesotho',
    de: 'Lesotho',
  },
  Liberia: {
    nl: 'Liberia',
    de: 'Liberia',
  },
  Libya: {
    nl: 'Libië',
    de: 'Libyen',
  },
  Liechtenstein: {
    nl: 'Liechtenstein',
    de: 'Liechtenstein',
  },
  Lithuania: {
    nl: 'Litouwen',
    de: 'Litauen',
  },
  Luxembourg: {
    nl: 'Luxemburg',
    de: 'Luxemburg',
  },
  Macao: {
    nl: 'Macau',
    de: 'Macao',
  },
  Madagascar: {
    nl: 'Madagaskar',
    de: 'Madagaskar',
  },
  Malawi: {
    nl: 'Malawi',
    de: 'Malawi',
  },
  Malaysia: {
    nl: 'Maleisië',
    de: 'Malaysia',
  },
  Maldives: {
    nl: 'Malediven',
    de: 'Malediven',
  },
  Mali: {
    nl: 'Mali',
    de: 'Mali',
  },
  Malta: {
    nl: 'Malta',
    de: 'Malta',
  },
  'Marshall Islands (the)': {
    nl: 'Marshalleilanden (de)',
    de: 'Marshallinseln (die)',
  },
  Martinique: {
    nl: 'Martinique',
    de: 'Martinique',
  },
  Mauritania: {
    nl: 'Mauritanië',
    de: 'Mauretanien',
  },
  Mauritius: {
    nl: 'Mauritius',
    de: 'Mauritius',
  },
  Mayotte: {
    nl: 'Mayotte',
    de: 'Mayotte',
  },
  Mexico: {
    nl: 'Mexico',
    de: 'Mexiko',
  },
  'Micronesia (Federated States of)': {
    nl: 'Micronesië (Federale Staten van)',
    de: 'Mikronesien (Föderierte Staaten von)',
  },
  'Moldova (the Republic of)': {
    nl: 'Moldavië (Republiek Moldavië)',
    de: 'Moldawien (die Republik)',
  },
  Monaco: {
    nl: 'Monaco',
    de: 'Monaco',
  },
  Mongolia: {
    nl: 'Mongolië',
    de: 'Mongolei',
  },
  Montenegro: {
    nl: 'Montenegro',
    de: 'Montenegro',
  },
  Montserrat: {
    nl: 'Montserrat',
    de: 'Montserrat',
  },
  Morocco: {
    nl: 'Marokko',
    de: 'Marokko',
  },
  Mozambique: {
    nl: 'Mozambique',
    de: 'Mosambik',
  },
  Myanmar: {
    nl: 'Myanmar',
    de: 'Myanmar',
  },
  Namibia: {
    nl: 'Namibië',
    de: 'Namibia',
  },
  Nauru: {
    nl: 'Nauru',
    de: 'Nauru',
  },
  Nepal: {
    nl: 'Nepal',
    de: 'Nepal',
  },
  Netherlands: {
    nl: 'Nederland',
    de: 'Niederlande',
  },
  'New Caledonia': {
    nl: 'Nieuw-Caledonië',
    de: 'Neukaledonien',
  },
  'New Zealand': {
    nl: 'Nieuw-Zeeland',
    de: 'Neuseeland',
  },
  Nicaragua: {
    nl: 'Nicaragua',
    de: 'Nicaragua',
  },
  'Niger (the)': {
    nl: 'Niger (de)',
    de: 'Niger (der)',
  },
  Nigeria: {
    nl: 'Nigeria',
    de: 'Nigeria',
  },
  Niue: {
    nl: 'Niue',
    de: 'Niue',
  },
  'Norfolk Island': {
    nl: 'Norfolk Eiland',
    de: 'Norfolkinsel',
  },
  'Northern Mariana Islands (the)': {
    nl: 'Noordelijke Marianen (de)',
    de: 'Nördliche Marianen (die)',
  },
  Norway: {
    nl: 'Noorwegen',
    de: 'Norwegen',
  },
  Oman: {
    nl: 'Oman',
    de: 'Oman',
  },
  Pakistan: {
    nl: 'Pakistan',
    de: 'Pakistan',
  },
  Palau: {
    nl: 'Palau',
    de: 'Palau',
  },
  'Palestine, State of': {
    nl: 'Palestina, Staat',
    de: 'Palästina, Staat',
  },
  Panama: {
    nl: 'Panama',
    de: 'Panama',
  },
  'Papua New Guinea': {
    nl: 'Papoea-Nieuw-Guinea',
    de: 'Papua-Neuguinea',
  },
  Paraguay: {
    nl: 'Paraguay',
    de: 'Paraguay',
  },
  Peru: {
    nl: 'Peru',
    de: 'Peru',
  },
  'Philippines (the)': {
    nl: 'Filipijnen (de)',
    de: 'Philippinen (die)',
  },
  Pitcairn: {
    nl: 'Pitcairn',
    de: 'Pitcairn',
  },
  Poland: {
    nl: 'Polen',
    de: 'Polen',
  },
  Portugal: {
    nl: 'Portugal',
    de: 'Portugal',
  },
  'Puerto Rico': {
    nl: 'Puerto Rico',
    de: 'Puerto Rico',
  },
  Qatar: {
    nl: 'Qatar',
    de: 'Katar',
  },
  'Republic of North Macedonia': {
    nl: 'Republiek Noord-Macedonië',
    de: 'Republik Nordmazedonien',
  },
  Romania: {
    nl: 'Roemenië',
    de: 'Rumänien',
  },
  'Russian Federation (the)': {
    nl: 'Russische Federatie (de)',
    de: 'Russische Föderation (die)',
  },
  Rwanda: {
    nl: 'Rwanda',
    de: 'Ruanda',
  },
  Réunion: {
    nl: 'Réunion',
    de: 'Réunion',
  },
  'Saint Barthélemy': {
    nl: 'Saint Barthélemy"',
    de: 'St. Barthélemy',
  },
  'Saint Helena, Ascension and Tristan da Cunha': {
    nl: 'Saint Helena, Ascension en Tristan da Cunha',
    de: 'St. Helena, Ascension und Tristan da Cunha',
  },
  'Saint Kitts and Nevis': {
    nl: 'Saint Kitts en Nevis',
    de: 'St. Kitts und Nevis',
  },
  'Saint Lucia': {
    nl: 'Saint Lucia',
    de: 'St. Lucia',
  },
  'Saint Martin (French part)': {
    nl: 'Saint Martin (Frans deel)',
    de: 'St. Martin (französischer Teil)',
  },
  'Saint Pierre and Miquelon': {
    nl: 'Saint Pierre en Miquelon',
    de: 'St. Pierre und Miquelon',
  },
  'Saint Vincent and the Grenadines': {
    nl: 'Saint Vincent en de Grenadines',
    de: 'St. Vincent und die Grenadinen',
  },
  Samoa: {
    nl: 'Samoa',
    de: 'Samoa',
  },
  'San Marino': {
    nl: 'San Marino',
    de: 'San Marino',
  },
  'Sao Tome and Principe': {
    nl: 'Sao Tomé en Principe',
    de: 'Sao Tome und Principe',
  },
  'Saudi Arabia': {
    nl: 'Saoedi-Arabië',
    de: 'Saudi-Arabien',
  },
  Senegal: {
    nl: 'Senegal',
    de: 'Senegal',
  },
  Serbia: {
    nl: 'Servië',
    de: 'Serbien',
  },
  Seychelles: {
    nl: 'Seychellen',
    de: 'Seychellen',
  },
  'Sierra Leone': {
    nl: 'Sierra Leone',
    de: 'Sierra Leone',
  },
  Singapore: {
    nl: 'Singapore',
    de: 'Singapur',
  },
  'Sint Maarten (Dutch part)': {
    nl: 'Sint Maarten (Nederlands deel)',
    de: 'Sint Maarten (niederländischer Teil)',
  },
  Slovakia: {
    nl: 'Slowakije',
    de: 'Slowakei',
  },
  Slovenia: {
    nl: 'Slovenië',
    de: 'Slowenien',
  },
  'Solomon Islands': {
    nl: 'Salomonseilanden',
    de: 'Salomonen',
  },
  Somalia: {
    nl: 'Somalië',
    de: 'Somalia',
  },
  'South Africa': {
    nl: 'Zuid-Afrika',
    de: 'Südafrika',
  },
  'South Georgia and the South Sandwich Islands': {
    nl: 'Zuid-Georgië en de Zuid-Sandwicheilanden',
    de: 'Südgeorgien und die Südlichen Sandwichinseln',
  },
  'South Sudan': {
    nl: 'Zuid-Soedan',
    de: 'Südsudan',
  },
  Spain: {
    nl: 'Spanje',
    de: 'Spanien',
  },
  'Sri Lanka': {
    nl: 'Sri Lanka',
    de: 'Sri Lanka',
  },
  'Sudan (the)': {
    nl: 'Soedan (de)',
    de: 'Sudan (der)',
  },
  Suriname: {
    nl: 'Suriname',
    de: 'Surinam',
  },
  'Svalbard and Jan Mayen': {
    nl: 'Svalbard en Jan Mayen',
    de: 'Svalbard und Jan Mayen',
  },
  Sweden: {
    nl: 'Zweden',
    de: 'Schweden',
  },
  Switzerland: {
    nl: 'Zwitserland',
    de: 'Schweiz',
  },
  'Syrian Arab Republic': {
    nl: 'Arabische Republiek Syrië',
    de: 'Syrische Arabische Republik',
  },
  Taiwan: {
    nl: 'Taiwan',
    de: 'Taiwan',
  },
  Tajikistan: {
    nl: 'Tadzjikistan',
    de: 'Tadschikistan',
  },
  'Tanzania, United Republic of': {
    nl: 'Tanzania, Verenigde Republiek',
    de: 'Tansania, Vereinigte Republik',
  },
  Thailand: {
    nl: 'Thailand',
    de: 'Thailand',
  },
  'Timor-Leste': {
    nl: 'Oost-Timor',
    de: 'Timor-Leste',
  },
  Togo: {
    nl: 'Togo',
    de: 'Togo',
  },
  Tokelau: {
    nl: 'Tokelau',
    de: 'Tokelau',
  },
  Tonga: {
    nl: 'Tonga',
    de: 'Tonga',
  },
  'Trinidad and Tobago': {
    nl: 'Trinidad en Tobago',
    de: 'Trinidad und Tobago',
  },
  Tunisia: {
    nl: 'Tunesië',
    de: 'Tunesien',
  },
  Turkey: {
    nl: 'Turkije',
    de: 'Türkei',
  },
  Turkmenistan: {
    nl: 'Turkmenistan',
    de: 'Turkmenistan',
  },
  'Turks and Caicos Islands (the)': {
    nl: 'Turks- en Caicoseilanden (de)',
    de: 'Turks- und Caicosinseln (die)',
  },
  Tuvalu: {
    nl: 'Tuvalu',
    de: 'Tuvalu',
  },
  Uganda: {
    nl: 'Oeganda',
    de: 'Uganda',
  },
  Ukraine: {
    nl: 'Oekraïne',
    de: 'Ukraine',
  },
  'United Arab Emirates (the)': {
    nl: 'Verenigde Arabische Emiraten (de)',
    de: 'Vereinigte Arabische Emirate (die)',
  },
  'United Kingdom of Great Britain and Northern Ireland (the)': {
    nl: 'Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland (de)',
    de: 'Vereinigtes Königreich von Großbritannien und Nordirland (the)',
  },
  'United States Minor Outlying Islands (the)': {
    nl: 'Amerikaanse ondergeschikte afgelegen eilanden (de)',
    de: 'United States Minor Outlying Islands (the)',
  },
  'United States of America (the)': {
    nl: 'Verenigde Staten van Amerika (de)',
    de: 'Vereinigte Staaten von Amerika (die)',
  },
  Uruguay: {
    nl: 'Uruguay',
    de: 'Uruguay',
  },
  Uzbekistan: {
    nl: 'Oezbekistan',
    de: 'Usbekistan',
  },
  Vanuatu: {
    nl: 'Vanuatu',
    de: 'Vanuatu',
  },
  'Venezuela (Bolivarian Republic of)': {
    nl: 'Venezuela (Bolivariaanse Republiek)',
    de: 'Venezuela (Bolivarische Republik)',
  },
  'Viet Nam': {
    nl: 'Vietnam',
    de: 'Vietnam',
  },
  'Virgin Islands (British)': {
    nl: 'Maagdeneilanden (Brits)',
    de: 'Jungferninseln (Britisch)',
  },
  'Virgin Islands (U.S.)': {
    nl: 'Maagdeneilanden (V.S.)',
    de: 'Jungferninseln (U.S.)',
  },
  'Wallis and Futuna': {
    nl: 'Wallis en Futuna',
    de: 'Wallis und Futuna',
  },
  'Western Sahara': {
    nl: 'Westelijke Sahara',
    de: 'Westsahara',
  },
  Yemen: {
    nl: 'Jemen',
    de: 'Jemen',
  },
  Zambia: {
    nl: 'Zambia',
    de: 'Sambia',
  },
  Zimbabwe: {
    nl: 'Zimbabwe',
    de: 'Simbabwe',
  },
  'Åland Islands': {
    nl: 'Åland-eilanden',
    de: 'Åland-Inseln',
  },
};

export const translateCountry = function(countryName, lang = 'nl') {
  if (!countryName) {
    return '';
  }

  let translated = COUNTRIES[countryName]?.[lang] || countryName;

  if (lang === 'en') {
    return countryName;
  }

  return translated;
};
